import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service/api-service';
import { API } from '../../API';

export interface Season {
  sportseason_id: number;
  sportseason_name: string;
  sportseason_status: string;
  sportseason_start_date: string;
  sportseason_end_date: string;
}

export interface LicencePeriod {
  licenceperiod_id: number;
  licenceperiod_name: string;
  licenceperiod_type: string;
  licenceperiod_status: string;
  sportseason_id: number;
  licenceperiod_start_date: string;
  licenceperiod_end_date: string;
}

@Injectable({ providedIn: 'root' })
export class SeasonsService {
  constructor(private api: ApiService) {}

  list(): Observable<any> {
    return this.api.get(API.SEASONS.LIST);
  }

  getActive(): Observable<any> {
    return this.api.get(API.SEASONS.ACTIVE);
  }

  create(body: any): Observable<any> {
    return this.api.post(API.SEASONS.CREATE, body);
  }

  get(id: number): Observable<any> {
    return this.api.get(API.SEASONS.GET.replace(':id', String(id)));
  }

  updateStatus(id: number, body: any): Observable<any> {
    return this.api.put(API.SEASONS.UPDATE_STATUS.replace(':id', String(id)), body);
  }

  getStats(id: number): Observable<any> {
    return this.api.get(API.SEASONS.STATS.replace(':id', String(id)));
  }

  getLicencePeriods(id: number): Observable<any> {
    return this.api.get(API.SEASONS.LICENCE_PERIODS.replace(':id', String(id)));
  }
}
